import { getSubscription } from "./api";
import { useAdminResource } from "./use-admin-resource";
import type { PlanFeature } from "./types";

export function useSubscription() {
  return useAdminResource(() => getSubscription(), []);
}

// While the subscription is still loading (or failed to load), features
// are treated as available -- matches the backend's own fail-open default
// for companies with no plan set, and avoids flashing a lock on every page
// load before the request resolves.
export function hasFeature(
  feature: PlanFeature,
  subscription: { features: PlanFeature[] } | null,
  loading: boolean,
): boolean {
  if (loading || !subscription) return true;
  return subscription.features.includes(feature);
}
